import { cn } from "../lib/cn";

/**
 * Colors must match DESIGN.md "Skeleton Colors and Theme Adherence"; size via
 * className (e.g. h-5 w-20), never children, which causes layout shift.
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-md bg-[#0000000f] dark:bg-white/6 animate-pulse",
        className,
      )}
      {...props}
    >
      <span
        className="absolute inset-0 loading-shimmer rounded-[inherit] pointer-events-none"
        aria-hidden
      />
    </div>
  );
}

export { Skeleton };
